<template>
  <div class="app-container">
    <div>
      <p>{{ $t("common.download_template_excel") }}</p>
      <i class="fa fa-download" aria-hidden="true"></i>
      <!-- <a href="/static/dataimport/import_asset_sample.xlsx" download="import_asset_sample">Download</a> -->
      <a @click="exportExcelFile">{{ $t("common.exportFileExcel") }}</a>
    </div>
    <upload-excel-component
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
    />
    <b-table
      striped
      hover
      small
      :items="resultImportList"
      :fields="resultImportList_fields"
      class="mt-3"
      outlined
      :busy="isLoading"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>{{ $t("reportLiabilitiesReport.loading") }}</strong>
        </div>
      </template>
      <template #head()="scope">
        <div>{{ $t(scope.label) }}</div>
      </template>
      <template slot="statusImport" slot-scope="row">
        <!-- {{row}} -->
        <p style="color:green" v-if="row.item.statusImport == 'Success'">
          {{ row.item.statusImport }}
        </p>
        <p style="color:red" v-else>{{ row.item.statusImport }}</p>
        <p />
      </template>
    </b-table>

    <div class="box-footer">
      <button
        id="cmdCancel"
        type="button"
        class="btn btn-default"
        @click="CancelList"
        style="margin-right: 5px;"
      >
        {{ $t("common.cancel") }}
      </button>
    </div>
  </div>
</template>

<script>
import UploadExcelComponent from "@/components/UploadExcel/index.vue";
// import utils from '@/lib/utils'
import { mapGetters, mapActions } from "vuex";
import XLSX from "xlsx";

export default {
  name: "AssetImportExcel",
  components: {
    UploadExcelComponent
  },
  data() {
    return {
      tableData: [],
      tableHeader: [],
      hdBackground: "background-color: #4b646f;border:1px solid white;", //00a65a

      resultImportList: [], // Result import
      resultImportList_fields: [
        {
          key: "asset_name",
          label: "escalationprocess.name",
          sortable: true,
          class: "text-center"
        },
        {
          key: "statusImport",
          label: "common.status",
          sortable: true,
          class: "text-center"
        },
        {
          key: "errorDetail",
          label: "common.error",
          sortable: true,
          class: "text-center"
        }
      ],
      isLoading: false,
      validateElement: {}
    };
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  methods: {
    ...mapActions([
      "IMPORT_MAINTAINANCE_FROM_EXCEL_FILE"
    ]),
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      this.$message({
        message: "Please do not upload files larger than 1m in size.",
        type: "warning"
      });
      return false;
    },

    handleSuccess({ results, header }) {
      this.tableData = results;
      let data = {
        headers: header,
        dataImport: results
      };
      // init empty
      this.resultImportList = [];
      this.isLoading = true;
      this.IMPORT_MAINTAINANCE_FROM_EXCEL_FILE(data)
        .then(
          function(res) {
            res.dataResult.forEach(v => {
              let dataPass = {
                asset_name: v.asset_name,
                statusImport: v.status,
                errorDetail: v.error_message
              };
              this.resultImportList.push(dataPass);
            });
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            let dataError = {
              asset_name: "Unknown",
              statusImport: "FAIL",
              errorDetail: "Unknown"
            };
            this.resultImportList.push(dataError);
            this.isLoading = false;
          }.bind(this)
        );
      this.tableHeader = header;
    },
    CancelList: function() {
      this.$router.push({
        name: "MaintenanceList"
      });
    },
    exportExcelFile: function() {
      let data_list = [];
      let json_data = [
        {
          "Mã thiết bị": "asset_1",
          "Tên thiết bị": "0000",
          "Ngày dự kiến bảo trì": "000",
          "Loại hình bảo dưỡng": "Tai san 1",
          "Chức năng bảo dưỡng": ""
        }
      ];

      data_list = json_data;
      // export json to Worksheet of Excel
      // only array possible
      var assetFile = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, assetFile, "maintenanceFile"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "MaintenanceFile.xlsx"); // name of the file is 'book.xlsx'
    }
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/views/Property/MaintenanceImportExcel.vue